<template>
  <div class="add-cleaner-modal">
    <el-form
      :rules="rules"
      :model="formData"
      inline
      label-position="top"
      ref="formRef"
    >
      <div class="font-18 m-b-15">基本信息</div>
      <el-row class="w-p-100">
        <el-col :span="8">
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model.trim="formData.name"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="手机号码" prop="phone">
            <el-input
              v-model.trim="formData.phone"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
        </el-col>
      </el-row>
      <el-row class="w-p-100">
        <el-col :span="8">
          <el-form-item label="人员类型" prop="staffType">
            <el-select v-model="formData.staffType">
              <el-option
                :label="type.name"
                :value="type.value"
                v-for="type in staffTypeList"
                :key="type.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="身份证号码" prop="certCode">
            <el-input
              v-model.trim="formData.certCode"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-collapse>
        <el-collapse-item>
          <template #title>
            单位信息<el-icon class="header-icon">
              <edit />
            </el-icon>
          </template>
          <el-row>
            <el-col :span="8">
              <el-form-item label="工作单位">
                <el-input
                  v-model.trim="formData.company"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工作地址">
                <el-input
                  v-model.trim="formData.companyAddress"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="入职时间">
                <el-date-picker
                  v-model="formData.hireDate"
                  type="datetime"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="请选择"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div class="align-c m-t-20 p-t-10">
      <el-button class="submit-btn" @click="handleSave">确定</el-button>
      <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ['cleanerId', 'storeId'],
  emits: ['close'],
  data() {
    return {
      staffTypeList: [{ name: '保洁', value: '01' }, { name: '维修', value: '02' }, { name: '其他', value: '09' },],
      formData: {
        name: '',
        phone: '',
        staffType: '01',
        certCode: '',
        wechatName: '',
        company: '',
        companyAddress: '',
        hireDate: '',
        storeId: this.storeId
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号码', trigger: 'blur' }, {
          validator: (rule, value, callback) => {
            if (value.length !== 11) {
              callback(new Error('请输入正确的手机号码'))
            } else {
              callback()
            }
          }, trigger: 'blur'
        }],
        staffType: [{ required: true, message: '请选择人员类型', trigger: 'blur' }],
        certCode: [{ required: true, message: '请输入身份证号码', trigger: 'blur' }, {
          validator: (rule, value, callback) => {
            if (value.length !== 18) {
              callback(new Error('请输入正确的身份证号码'))
            } else {
              callback()
            }
          }, trigger: 'blur'
        }],
      }
    }
  },

  created() {
    if (this.cleanerId) {
      this.getDetail();
    }
  },

  methods: {
    ...mapActions(["fetchData"]),

    // 详情
    getDetail() {
      this.fetchData({
        url: 'CLEAN.CLEANER.GET_DETAIL',
        method: 'get',
        params: { id: this.cleanerId }
      }).then(res => {
        if (res) {
          this.formData = res
        } else {
          this.$message.error('数据获取失败')
        }
      }).catch(err => {
        this.$message.error('数据获取失败')
      })
    },

    // 提交
    handleSave() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          this.fetchData({
            url: 'CLEAN.CLEANER.POST_SAVE',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            params: this.formData
          }).then(res => {
            if (res) {
              this.$message.success('操作成功')
              this.handleCancel(true);
            } else {
              this.$message.error('操作失败')
            }
          }).catch(err => {
            this.$message.error('操作失败')
          })
        }
      })
    },

    // 关闭对话框
    handleCancel(success) {
      this.$emit('close', success)
    },
  }
}
</script>

<style lang="less" scoped>
.add-cleaner-modal {
  :deep(.el-collapse) {
    border: none;
    .el-collapse-item__header {
      font-size: 18px;
      margin-bottom: 5px;
      border-bottom: none;
      .el-collapse-item__arrow {
        display: none;
      }
      .header-icon {
        margin-left: 10px;
        color: #00c0c0;
      }
    }
    .el-collapse-item__wrap {
      border-bottom: none;
    }
  }
}
</style>